import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { isEditableKeyboardTarget, isUndoKeyboardEvent, visibleToastSlice } from '@gh/core-ui';
import { Subscription } from 'rxjs';
import { ToastContext } from './toast-context.service';
import { ToastItem } from './toast-item';

@Component({
  standalone: false,
  selector: 'gh-toast-panel',
  templateUrl: 'toast-panel.component.html',
  styleUrls: ['toast-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastPanelComponent implements OnInit, OnDestroy, DoCheck {
  visible: ToastItem[] = [];
  overflowCount = 0;

  private pending: ToastItem[] = [];
  private subscription: Subscription;

  constructor(private context: ToastContext,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.subscription = this.context.subscribe((items) => {
      this.pending = items;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngDoCheck(): void {
    const slice = visibleToastSlice(this.pending);
    this.visible = slice.visible;
    this.overflowCount = slice.overflowCount;
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (!isUndoKeyboardEvent(event) || isEditableKeyboardTarget(event.target)) {
      return;
    }
    if (this.context.undoTop()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
